import React, { PropsWithChildren, useRef } from 'react';
import { cx } from 'linaria';
import { Tooltip } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { useHandleEscPress } from 'common/hooks/use-handle-esc-press';
import { useClickOutside } from 'components/header/hooks';
import { hintWrapper } from 'components/header/styles/hint-wrapper';
import { Content } from './menu-content/';
import { TooltipProfileClassName } from 'components/header/components/profile/styles/tooltip';

type UserMenuTooltipProps = {
  onLogout: () => void;
  isVisibleTooltip: boolean;
  organizationName?: string;
  organizationCount: number;
  setVisibleTooltip: (value: boolean) => void;
  showChangeOrganizationPopup: () => void;
};

export const UserMenuTooltip = (props: PropsWithChildren<UserMenuTooltipProps>) => {
  const ref = useRef<HTMLDivElement>(null);

  useClickOutside(ref, () => props.setVisibleTooltip(false));
  useHandleEscPress(() => () => props.setVisibleTooltip(false), props.isVisibleTooltip);

  if (props.isVisibleTooltip) {
    return (
      <Tooltip
        placement="bottom"
        className={cx(TooltipProfileClassName, hintWrapper)}
        open={true}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        title={
          <Content
            ref={ref}
            onLogout={props.onLogout}
            organizationName={props.organizationName}
            organizationCount={props.organizationCount}
            showChangeOrganizationPopup={props.showChangeOrganizationPopup}
          />
        }
      >
        {props.children}
      </Tooltip>
    );
  }

  return <Title>{props.children}</Title>;
};

const Title = (props: PropsWithChildren<unknown>) => {
  const { t } = useTranslation();

  return (
    <Tooltip placement="bottom" title={t('header.main.profile')}>
      {props.children}
    </Tooltip>
  );
};
